import { RootState } from '../../rootReducer'
import { sortByOrder } from '../../utils/sortUtil'
import { createSelector } from 'reselect'

const filtersListSelector = (state: RootState) => state.policies.filters?.list
const filtersColumnSelector = (state: RootState) => state.policies.filters?.sort.column
const filtersDirectionSelector = (state: RootState) => state.policies.filters?.sort.direction

const rulsetListSelector = (state: RootState) => state.policies.rulesets.list
const rulsetColumnSelector = (state: RootState) => state.policies.rulesets.sort.column
const rulsetDirectionSelector = (state: RootState) => state.policies.rulesets.sort.direction

const alertsGroupListSelector = (state: RootState) => state.policies.alertGroups.list
const alertsGroupColumnSelector = (state: RootState) => state.policies.alertGroups.sort.column
const alertsGroupDirectionSelector = (state: RootState) => state.policies.alertGroups.sort.direction

export const getAlertsGroupListSorted = createSelector(
  [alertsGroupListSelector, alertsGroupColumnSelector, alertsGroupDirectionSelector],
  (list, column, direction) => {
    return list?.length && column ? sortByOrder(list, column, direction) : list
  }
)

export const getFiltersListSorted = createSelector(
  [filtersListSelector, filtersColumnSelector, filtersDirectionSelector],
  (list, column, direction) => {
    return list?.length && column ? sortByOrder(list, column, direction) : list
  }
)

const mapDataListSelector = (state: RootState) => state.policies.profileMapColumnsData?.list
const mapDataColumnSelector = (state: RootState) =>
  state.policies.profileMapColumnsData?.sort.column
const mapDataDirectionSelector = (state: RootState) =>
  state.policies.profileMapColumnsData?.sort.direction

export const getProfileMapListSorted = createSelector(
  [mapDataListSelector, mapDataColumnSelector, mapDataDirectionSelector],
  (list, column, direction) => {
    return list?.length && column ? sortByOrder(list, column, direction) : list
  }
)

export const getRulesetListSorted = createSelector(
  [rulsetListSelector, rulsetColumnSelector, rulsetDirectionSelector],
  (list, column, direction) => {
    return list?.length && column ? sortByOrder(list, column, direction) : list
  }
)
